// Replicates the WBS table's row numbering: milestones "M1..", tasks "{phase}.{n[.n]}".
export function computeWbsIds(tasks, phases) {
  const map = {};
  let ms = 0;
  tasks.filter((t) => t.is_milestone).forEach((t) => { map[t.id] = `M${++ms}`; });
  const byOrder = (a, b) => (a.order || 0) - (b.order || 0);
  (phases || []).forEach((g, pi) => {
    const all = tasks.filter((t) => t.phase === g);
    const top = all.filter((t) => !t.parent_id || !all.some((p) => p.id === t.parent_id)).sort(byOrder);
    const walk = (t, num) => {
      if (!t.is_milestone) map[t.id] = `${pi + 1}.${num}`;
      const kids = tasks.filter((k) => k.parent_id === t.id).sort(byOrder);
      kids.forEach((k, i) => walk(k, `${num}.${i + 1}`));
    };
    top.forEach((t, i) => walk(t, i + 1));
  });
  return map;
}
